module.exports = __webpack_public_path__ + "static/media/与书对话.7432b2e2.png";